<template>
    <rkm-data-table
        :fields="fields"
        :repository="repositories.notificacao"
        ref="DataTable"
        sort-by="dataHoraAtualizacao"
        :sort-desc="true"
    >
        <template v-slot:cell(actions)="{item}">
            <rkm-button
                @click.stop="$router.push({name: 'administracao-notificacao-edit', params: {id: item.id}})"
                authorize="update-administracao-notificacao"
                color="primary"
                small
                title="Editar"
            >
                <rkm-icon icon="pen" />
            </rkm-button>

            <rkm-button
                @click.stop="destroy(item)"
                authorize="destroy-administracao-notificacao"
                color="danger"
                small
                title="Excluir"
            >
                <rkm-icon icon="trash" />
            </rkm-button>
        </template>
    </rkm-data-table>
</template>

<script>
// Mixins.
import {error, repository} from '@/mixins'

export default {
    created() {
        this.repositories = {
            notificacao: this.getConectaSusRepository('administracao.notificacao')
        }
    },
    data: () => ({
        fields: [
            {key: 'dataHoraAtualizacao', label: 'Data/Hora', searchable: true, sortable: true},
            {key: 'tipoNome', label: 'Tipo', name: 'administracao_notificacao_tipo.nome', searchable: true, sortable: true},
            {key: 'titulo', label: 'Título', name: 'administracao_notificacao.titulo', searchable: true, sortable: true},
            {class: 'col-min text-center', key: 'actions', label: 'Ações'},
        ],
    }),
    methods: {
        destroy({ id }) {
            const destroy = () => this.repositories.notificacao.destroy(id)
                .then(() => this.$refs.DataTable.refresh())

            this.showDeleteConfirmation('Deseja realmente excluir a notificação?', destroy, this.handleError)
        },
    },
    mixins: [error, repository],
}
</script>